<common-modal
  [nextActionName]="nextActionName"
  [previousActionName]="previousActionName"
  [isSkippable]="isSkippable"
  [isReady]="true"
  [isWithProgress]="true"
  [isWithProgress]="false"
  [progress]="progress"
  [progressLabel]="''"
  [isUpdating]="isCreatingTeam || isCreatingMap"
  (next)="nextStep()"
  (previous)="previousStep()"
  >
  @if (currentStep === 'Welcome') {
    <ng-container *ngTemplateOutlet="welcome"></ng-container>
  }

  @if (currentStep === 'CreateTeam') {
    <ng-container *ngTemplateOutlet="createteam"></ng-container>
  }

  @if (currentStep === 'Terminology') {
    <ng-container *ngTemplateOutlet="terminology"></ng-container>
  }

  @if (currentStep === 'Pricing') {
    <ng-container *ngTemplateOutlet="pricing"></ng-container>
  }

  @if (currentStep === 'Consent') {
    <ng-container *ngTemplateOutlet="consent"></ng-container>
  }
</common-modal>

<ng-template #welcome>
  <ng-template #yourfirstmap i18n>
    <span class="text-accent">👋 {{ user?.firstname }}</span>
    <ng-container>, your first map is just a few clicks away!</ng-container>
  </ng-template>
  <ng-template #guide i18n>
    Let's set up your organisation. It will only take a minute.
  </ng-template>

  <div class="display-3 d-none d-md-block">
    <ng-container *ngTemplateOutlet="yourfirstmap"></ng-container>
  </div>
  <div class="h1 d-md-none">
    <ng-container *ngTemplateOutlet="yourfirstmap"></ng-container>
  </div>

  <h4 class="my-4 text-muted d-none d-md-block">
    <ng-container *ngTemplateOutlet="guide"></ng-container>
  </h4>

  <h6 class="my-4 text-muted d-md-none">
    <ng-container *ngTemplateOutlet="guide"></ng-container>
  </h6>
</ng-template>

<ng-template #createteam>
  <ng-template
    #createteamtitle
    i18n="Onboarding - Heading of one of the onboarding screens"
    >
    What should we call your organisation?
  </ng-template>

  <h1 class="text-center d-none d-md-block">
    <ng-container *ngTemplateOutlet="createteamtitle"></ng-container>
  </h1>
  <h3 class="text-center d-md-none">
    <ng-container *ngTemplateOutlet="createteamtitle"></ng-container>
  </h3>
  <div class="my-3 my-md-5">
    <div
      class="form-row w-100 d-flex justify-content-center align-items-center flex-column"
      >
      <div class="col-12 col-md-10 col-lg-6">
        <input [(ngModel)]="team.name" type="text" class="form-control" />
        @if (teamCreationErrorMessage) {
          <small class="form-text text-danger">
            {{ teamCreationErrorMessage }}
          </small>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #terminology>
  <ng-template
    #terminologytitle
    i18n="
      Heading of onboarding screen on lead and helper terminology
      @@onboarding-terminology-1"
    >
    What should we call them?
  </ng-template>

  <ng-template #terminologysubtitle>
    <span
      class="text-muted"
      i18n="
        Subheading of onboarding screen on lead and helper terminology
        @@onboarding-terminology-2"
      >
      What language do you use to refer to people at
      <b>{{ team.name }}</b>
      ?
    </span>
  </ng-template>

  <ng-template #settingsnote>
    <span
      class="text-muted"
      i18n="
        Helper text for onboarding screen on lead and helper terminology
        @@onboarding-terminology-3"
      >
      You can always change this later in the organisation settings.
    </span>
  </ng-template>

  <h1 class="text-center d-none d-md-block">
    <ng-container *ngTemplateOutlet="terminologytitle"></ng-container>
  </h1>
  <h3 class="text-center d-md-none">
    <ng-container *ngTemplateOutlet="terminologytitle"></ng-container>
  </h3>

  <h4 class="text-center d-none d-md-block">
    <ng-container *ngTemplateOutlet="terminologysubtitle"></ng-container>
  </h4>
  <h6 class="text-center d-md-none">
    <ng-container *ngTemplateOutlet="terminologysubtitle"></ng-container>
  </h6>

  <div class="my-5">
    <onboarding-add-terminology
      [team]="team"
      (saved)="onTerminologySaved()"
    ></onboarding-add-terminology>
  </div>

  <div class="h5 text-center d-none d-md-block">
    <ng-container *ngTemplateOutlet="settingsnote"></ng-container>
  </div>
  <div class="h6 text-center d-md-none">
    <ng-container *ngTemplateOutlet="settingsnote"></ng-container>
  </div>
</ng-template>

<ng-template #pricing>
  <ng-template
    #pricingtitle
    i18n="Heading for pricing screen during onboarding@@onboarding-pricing-1"
    >
    A quick note about pricing
  </ng-template>

  <ng-template #pricingcontent>
    <img
      src="assets/images/tom.png"
      alt="Portrait photo of Tom Nixon"
      class="float-start rounded-circle w-25 m-3"
      />

    <p
      class="text-muted pt-4"
      i18n="Text for pricing screen during onboarding@@onboarding-pricing-2"
      >
      Hey, it's Tom here &mdash; the founder of Maptio&hellip;
    </p>

    <p
      class="text-muted fw-bold"
      i18n="Text for pricing screen during onboarding@@onboarding-pricing-3"
      >
      We are funded by subscriptions from our customers, but unlike most
      software, Maptio has no fixed pricing. Each customer chooses their own
      price to fit the value they get and their financial means.
    </p>

    <p
      class="text-muted"
      i18n="Text for pricing screen during onboarding@@onboarding-pricing-4"
      >
      After your free trial, if you love Maptio we'll help you decide what the
      right contribution is for you. Read more on our
      <a href="https://www.maptio.com/pricing" target="_blank">Pricing</a>
      page.
    </p>
  </ng-template>

  <h1 class="text-center d-none d-md-block">
    <ng-container *ngTemplateOutlet="pricingtitle"></ng-container>
  </h1>
  <h3 class="text-center d-md-none">
    <ng-container *ngTemplateOutlet="pricingtitle"></ng-container>
  </h3>

  <h4 class="text-center d-none d-md-block">
    <ng-container *ngTemplateOutlet="pricingsubtitle"></ng-container>
  </h4>
  <h6 class="text-center d-md-none">
    <ng-container *ngTemplateOutlet="pricingsubtitle"></ng-container>
  </h6>

  <div class="h5 d-none d-md-block">
    <ng-container *ngTemplateOutlet="pricingcontent"></ng-container>
  </div>
  <div class="h6 d-md-none">
    <ng-container *ngTemplateOutlet="pricingcontent"></ng-container>
  </div>
</ng-template>

<ng-template #consent>
  <ng-template
    #consenttitle
    i18n="Heading for consent screen during onboarding@@onboarding-consent-1"
    >
    Could you help us improve Maptio?
  </ng-template>

  <ng-template #consentcontent>
    <img
      src="assets/images/tom.png"
      alt="Portrait photo of Tom Nixon"
      class="float-start rounded-circle w-25 m-3"
      />

    <p
      class="text-muted pt-4"
      i18n="Text for consent screen during onboarding@@onboarding-consent-2"
      >
      One last thing from me&hellip;
    </p>

    <p
      class="text-muted"
      i18n="Text for consent screen during onboarding@@onboarding-consent-3"
      >
      We're doing all we can to make Maptio ever more delightful to use.
    </p>

    <p
      class="text-muted"
      i18n="Text for consent screen during onboarding@@onboarding-consent-4"
      >
      With your permission, we'd like to make session recordings of your
      activity using Maptio. This helps us spot where we can make improvements.
    </p>

    <p
      class="text-muted"
      i18n="Text for consent screen during onboarding@@onboarding-consent-5"
      >
      We use a very privacy-conscious service called
      <a href="https://openreplay.com/" target="_blank">OpenReplay</a>
      . It's open source, just like us. We trust their service to keep
      recordings private and secure.
    </p>

    <maptio-consent [user]="user" class="d-block my-4"></maptio-consent>

    <p
      class="text-muted"
      i18n="Text for consent screen during onboarding@@onboarding-consent-6"
      >
      If you choose to continue without ticking that checkbox, we respect that.
      We'd still love to hear how you get on with using Maptio, so please do let
      us know if you have questions or suggestions. Thank you!
    </p>
  </ng-template>

  <h1 class="text-center d-none d-md-block">
    <ng-container *ngTemplateOutlet="consenttitle"></ng-container>
  </h1>
  <h3 class="text-center d-md-none">
    <ng-container *ngTemplateOutlet="consenttitle"></ng-container>
  </h3>

  <h4 class="text-center d-none d-md-block">
    <ng-container *ngTemplateOutlet="consentsubtitle"></ng-container>
  </h4>
  <h6 class="text-center d-md-none">
    <ng-container *ngTemplateOutlet="consentsubtitle"></ng-container>
  </h6>

  <div class="h5 d-none d-md-block">
    <ng-container *ngTemplateOutlet="consentcontent"></ng-container>
  </div>
  <div class="h6 d-md-none">
    <ng-container *ngTemplateOutlet="consentcontent"></ng-container>
  </div>
</ng-template>
